// 二次编辑页面
import React, {useState} from 'react';
import { Input, Flex, Button } from 'antd';
import { SaveOutlined } from '@ant-design/icons';

import { parseDatFile } from './utils/datParser';
import { generateParsedTreeData } from './utils/parseDatForTree';


const { TextArea } = Input;
const EditingPage = ({ setIsEditing, fileContent, setParsedTreeData }) => {
    // 编辑内容
    const [content, setContent] = useState(fileContent || '');

    // 保存数据，并返回解析页面
    const handleSaveAndReturn = () => {
        // 保存逻辑
        const sections = parseDatFile(content);
        const parsedTreeData = generateParsedTreeData(sections);
        setParsedTreeData(parsedTreeData);
        // 返回解析页面
        setIsEditing(false);
    }

    // 返回编辑页面
    const handleReturn = () => {
        setIsEditing(false);
    }

    return (
        <Flex vertical justify='flex-start' align='center' gap='middle' style={{ width: '100%', height: '100%' }}>
            <Flex justify='space-between' align='center' style={{ width: '100%', marginBottom: 10 }}>
                <Button onClick={handleReturn}>返回</Button>
                <Button color='primary' variant="outlined" icon={<SaveOutlined />} onClick={handleSaveAndReturn}>保存</Button>
            </Flex>
            <TextArea
                style={{ width: '100%', flex: 1 }} autoSize={true}
                placeholder="请输入内容"
                defaultValue={fileContent}
                onChange={(e) => {
                    setContent(e.target.value);
                }}
            />
        </Flex>
    );
};

export default EditingPage;